export const FIND_REF_RESULTS_REQUEST = 'FIND_REF_RESULTS_REQUEST';

export const findRefResultsRequest = ( id ) => ({
    type: FIND_REF_RESULTS_REQUEST,
    payload: { id }
});
